import { render, staticRenderFns } from "./HomeBtn.vue?vue&type=template&id=9d6502fc"
import script from "./HomeBtn.vue?vue&type=script&lang=js"
export * from "./HomeBtn.vue?vue&type=script&lang=js"
import style0 from "./HomeBtn.vue?vue&type=style&index=0&id=9d6502fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports